export default __webpack_public_path__ + "static/media/banner6.e50898da.jpg";